import { render, staticRenderFns } from "./materialGRIC1.vue?vue&type=template&id=143f033d&scoped=true"
import script from "./materialGRIC1.vue?vue&type=script&lang=js"
export * from "./materialGRIC1.vue?vue&type=script&lang=js"
import style0 from "./materialGRIC1.vue?vue&type=style&index=0&id=143f033d&lang=scss&scoped=true"
import style1 from "./materialGRIC1.vue?vue&type=style&index=1&id=143f033d&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143f033d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('143f033d')) {
      api.createRecord('143f033d', component.options)
    } else {
      api.reload('143f033d', component.options)
    }
    module.hot.accept("./materialGRIC1.vue?vue&type=template&id=143f033d&scoped=true", function () {
      api.rerender('143f033d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/material/material-master-data/materialGRIC1.vue"
export default component.exports